<!-- EmailInput.vue -->
 <script setup lang="ts">
import TextInput from '../TextInput.vue';
import { ModelValue } from '@vuepic/vue-datepicker';
import * as Validation from '../../lib/Validation';
import Icon from '../Icon.vue';
import { DisplayStyle, IconTypes } from '../../Enums/UiEnums';
import { computed, ref } from 'vue';

    defineExpose({ focus });  

    const textInput = ref();

    const props = defineProps<{
        modelValue: string|undefined,
        title?: string,
        disabled?: boolean,
        placeholder?: string,
        maxLength?: number
    }>();

    const emits = defineEmits<{
        "update:modelValue": [val: string|undefined]
    }>();

    function isValidEmail(email?: string): boolean
    {
        if (!email || 0 === email.trim().length)
            return true;
        return Validation.isValidEmail(email);
    }

    const showEmailError = computed<boolean>(() => !isValidEmail(props.modelValue));
    const iconDisplayStyle = computed<DisplayStyle>(() => props.disabled ? DisplayStyle.Dark : DisplayStyle.Primary);

    function emitsValue(val: string|undefined)
    {
        emits('update:modelValue', val);
    }

    function focus()
    {
        textInput.value?.focus();
    }
</script>

<template>
    <TextInput
        ref="textInput" 
        :textValue="props.modelValue"
        :title="props.title"
        :disabled="props.disabled"
        :placeholder="props.placeholder"
        :validator="isValidEmail"
        :hideRightAddOn="!showEmailError"
        :rightAddOnDisplayStyle="DisplayStyle.Danger"
        :maxLength="props.maxLength"
        @update:textValue="emitsValue">
        <template #LeftAddon>
            <Icon :icon="IconTypes.Email" :displayStyle="iconDisplayStyle"/>
        </template>
        <template #RightAddon>
            <Icon :icon="IconTypes.Error" :displayStyle="DisplayStyle.Light" title="Invalid email" />
        </template>
    </TextInput>
</template>